import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useContext } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { MaxLengths } from '../../../../utils/constants';
import { MlifeActivationContext } from '../../MlifeActivationContext';

export function LastName() {
  const { activationRequest } = useContext(MlifeActivationContext);
  const { getContentByPath } = useContent();

  return (
    <TextInput
      variant='default'
      label={getContentByPath('mlifeActivation.accountSetupSection.fields.lastName.title')}
      id='lastName'
      testId='lastName'
      disabled
      icon='lock'
      className={`identity__field identity__field-lastName`}
      value={activationRequest?.lName ?? ''}
      maxLength={MaxLengths.LastName}
    />
  );
}

LastName.displayName = 'LastNameField';
